import { render, staticRenderFns } from "./SuppliersBookingSettingsCustomField.vue?vue&type=template&id=2271c09c&"
import script from "./SuppliersBookingSettingsCustomField.vue?vue&type=script&lang=js&"
export * from "./SuppliersBookingSettingsCustomField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports